import PostActionTypes from "./post.types";

const INITIAL_STATE = {
  posts: [],
  error: null,
  loading: false,
  message: null,
}

const postReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PostActionTypes.GET_POSTS_START:
    case PostActionTypes.CREATE_POSTS_START:
    case PostActionTypes.LIKE_POST_START:
    case PostActionTypes.COMMENT_POST_START:
      return {
        ...state,
        loading: true,
      }
    case PostActionTypes.GET_POSTS_SUCCESS:
      return {
        ...state,
        loading: false,
        posts: action.payload,
      }
    case PostActionTypes.GET_POSTS_FAILURE:
    case PostActionTypes.CREATE_POSTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case PostActionTypes.CREATE_POSTS_SUCCESS:
      return {
        ...state,
        loading: false
      }
    case PostActionTypes.LIKE_POST_SUCCESS:
    case PostActionTypes.COMMENT_POST_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload,
      }
    case PostActionTypes.LIKE_POST_FAILURE:
    case PostActionTypes.COMMENT_POST_FAILURE:
      return {
        ...state,
        loading: false,
        message: null,
        error: action.payload,
      }
    default:
      return state;
  }
}

export default postReducer;